import en from '@/i18n/lang/en/en'
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login/index'
import Layout from '@/views/layout/layout'
import HomeMain from '@/views/index/mainIndex'
import Main from '@/views/main/index'
import forgetPassword from '@/views/login/forgetPassword'
import modifyPassword from '@/views/login/modifyPassword.vue'
import register from '@/views/login/register'
// 不是必须加载的组件使用懒加载
const NotFound = () => import('@/page404')

Vue.use(Router)

// 导入 sys 模块路由
import message from './modules/ims/message'
import flow from './modules/flow/flow'

//消除路由重复报错
const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
　　return originalPush.call(this, location).catch(err => err)
}

let routeName = en.routeName
let defaultRouter = [
  {
    path: '/',
    redirect: '/main',
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/login',
    component: Login,
    name: '',
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/forgetPassword',
    name: '',
    component: forgetPassword,
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/modifyPassword',
    name: 'modifyPassword',
    component: modifyPassword,
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/main',
    component: Main,
    name: 'main',
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/newsList/:type',
    component: () => import('@/views/main/newsList.vue'),
    name: 'newsList',
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/news/:id',
    component: () => import('@/views/main/news.vue'),
    name: 'news',
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/systemList',
    component: () => import('@/views/main/system-list.vue'),
    name: 'systemList',
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/noticeLists',
    component: () => import('@/views/main/notice-list.vue'),
    name: 'noticeLists',
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/searchPerson',
    component: () => import('@/views/base/user/search-person.vue'),
    name: 'searchPerson',
    hiddenFlag: 'Y',
    children: []
  },
  {
    path: '/index',
    name: routeName.home,
    component: Layout,
    hiddenFlag: 'N',
    alone: true,
    children: [
      {
        path: '/index',
        name: '主页',
        component: HomeMain,
        hiddenFlag: 'N',
        children: []
      }
    ]
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hiddenFlag: true,
    children: []
  }
]

let addRouter = [
  {
    path: '*',
    redirect: '/404',
    hiddenFlag: true,
    children: []
  }
]

let myRouter = [
  // ...wechat, // 微信
  // ...pmc, // 商品
  // ...order, // 订单
  // ...sales, // 营销活动
  // ...account, // 资金
  // ...ims, // 库存ims模块的部分路由：动销数据
  // ...designer, // 设计师
  // ...mcc, // 会员
  // ...cmc, // 渠道
  // ...cms, // cms模块所有的路由
  // ...base, // 基础资料
  ...message, // 系统
  ...flow // 流程
]
// 创建路由实例
export default new Router({
  routes: [...defaultRouter, ...myRouter, ...addRouter]  // 注意路由顺序
})
export {defaultRouter, addRouter, myRouter}



// WEBPACK FOOTER //
// ./src/router/index.js